// Shared react-query key for the aggregate prepaid-products list. Referenced by the
// list query and by every mutation that needs to refresh it (add/cancel/email-invoice),
// so it lives in one place to avoid the keys drifting out of sync.
export const PREPAID_PRODUCTS_QUERY_KEY = 'prepaid-products';
